/* Deutsch */
const de = {
  "nav.home":      "Startseite",
  "nav.plans":     "Tarife",
  "nav.devices":   "Geräte",
  "nav.app":       "App holen",
  "nav.dashboard": "Dashboard",
  "nav.login":     "Anmelden",
  "nav.register":  "Registrieren",
  "nav.logout":    "Abmelden",
  "nav.account":   "Konto",

  "hero.kicker":      "Grenzenlose Unterhaltung",
  "hero.title":       "Bring das Kino nach Hause.",
  "hero.subtitle":    "Die beliebtesten Live-TV-Kanäle, dazu hunderte Filme und Serien. In 4K. Auf all deinen Geräten. Ein Abo.",
  "hero.cta.primary": "Tarife ansehen",
  "hero.cta.ghost":   "Ich bin schon Mitglied",
  "hero.trust":       "Sichere 24/7-Kartenzahlung • Sofortige Aktivierung • Jederzeit kündbar",

  "section.features.kicker":   "Warum wir",
  "section.features.title":    "Premium-Streaming-Erlebnis.",
  "feature.4k.title":          "4K UHD-Qualität",
  "feature.4k.desc":           "Kinoqualität auf unterstützten Titeln.",
  "feature.library.title":     "Riesige Bibliothek",
  "feature.library.desc":      "Filme, Serien, Doku-Reihen, Live-Sport und mehr.",
  "feature.devices.title":     "Jedes Gerät",
  "feature.devices.desc":      "Android, iOS, Smart TV, Fire TV, Apple TV und mehr.",
  "feature.support.title":     "24/7-Support",
  "feature.support.desc":      "Echte Menschen — keine Bots. Durchschnittlich 5 Min. Antwortzeit.",

  "section.plans.kicker":      "Tarife",
  "section.plans.title":       "Wähle die passende Laufzeit.",
  "section.plans.subtitle":    "Längere Laufzeiten kosten pro Monat weniger. Jederzeit kündbar.",

  "section.cta.title":         "Mach heute zum Kinoabend.",
  "section.cta.subtitle":      "In Sekunden registrieren, sofort streamen.",
  "section.cta.button":        "Jetzt starten",

  "plans.page.title":          "Tarife",
  "plans.page.subtitle":       "3, 6 oder 12 Monate. Wähle, was zu dir passt.",
  "plans.months":              "{n} Monate",
  "plans.per_month":           "/Mon.",
  "plans.billed_total":        "{amount} einmalig",
  "plans.select":              "Diesen Tarif wählen",
  "plans.current":             "Dein aktueller Tarif",
  "plans.badge.popular":       "Am beliebtesten",
  "plans.badge.best_value":    "Bester Wert",

  "feature.channels_12k":      "Großes Live-Kanal-Angebot",
  "feature.vod_library":       "Komplette VOD-Bibliothek",
  "feature.fhd_1080p":         "Full HD 1080p",
  "feature.uhd_4k":            "4K UHD auf unterstützten Titeln",
  "feature.two_devices":       "Bis zu 2 Geräte",
  "feature.three_devices":     "Bis zu 3 Geräte",
  "feature.five_devices":      "Bis zu 5 Geräte",
  "feature.seven_day_epg":     "7-Tage-EPG",
  "feature.fourteen_day_epg":  "14-Tage-EPG",
  "feature.priority_support":  "Priorisierter Support",
  "feature.early_access":      "Früher Zugriff auf neue Features",

  "auth.login.title":          "Willkommen zurück.",
  "auth.login.subtitle":       "Melde dich an, um weiterzustreamen.",
  "auth.register.title":       "Konto erstellen.",
  "auth.register.subtitle":    "Starte dein Abo in 30 Sekunden.",
  "auth.forgot.title":         "Passwort vergessen?",
  "auth.forgot.subtitle":      "Gib deine E-Mail ein, wir senden einen Reset-Link.",
  "auth.field.email":          "E-Mail",
  "auth.field.password":       "Passwort",
  "auth.field.name":           "Vollständiger Name",
  "auth.field.confirm":        "Passwort (Bestätigung)",
  "auth.submit.login":         "Anmelden",
  "auth.submit.register":      "Konto erstellen",
  "auth.submit.forgot":        "Reset-Link senden",
  "auth.forgot.link":          "Passwort vergessen",
  "auth.no_account":           "Noch kein Konto?",
  "auth.has_account":          "Schon ein Konto?",
  "auth.back_to_login":        "Zurück zur Anmeldung",
  "auth.terms":                "Mit der Registrierung akzeptierst du unsere {terms} und {privacy}.",
  "auth.terms.terms":          "Nutzungsbedingungen",
  "auth.terms.privacy":        "Datenschutz",
  "auth.forgot.sent":          "Link gesendet. Prüfe dein Postfach.",

  "dash.hello":                "Hallo, {name}",
  "dash.welcome":              "Verwalte dein Abo und deine Geräte hier.",
  "dash.subscription.title":   "Dein Abo",
  "dash.subscription.plan":    "Tarif",
  "dash.subscription.status":  "Status",
  "dash.subscription.active":  "AKTIV",
  "dash.subscription.expires": "Läuft ab am",
  "dash.subscription.days":    "Noch {n} Tage",
  "dash.subscription.renew":   "Verlängern",
  "dash.subscription.upgrade": "Upgraden",
  "dash.subscription.none":    "Du hast noch kein aktives Abo. Wähle deinen ersten Tarif und leg los.",
  "dash.subscription.cta":     "Tarif wählen",

  "dash.devices.title":        "Geräte",
  "dash.devices.count":        "{n} / {max} aktiv",
  "dash.devices.manage":       "Verwalten",

  "dash.account.title":        "Konto",
  "dash.account.email":        "E-Mail",
  "dash.account.member":       "Mitglied seit",

  "dash.quick.app":            "App herunterladen",
  "dash.quick.plans":          "Tarife ansehen",
  "dash.quick.support":        "Hilfe holen",

  "devices.title":             "Geräteverwaltung",
  "devices.subtitle":          "Geräte, die derzeit auf deinem Konto streamen dürfen.",
  "devices.add":               "Gerät hinzufügen",
  "devices.name":              "Gerät",
  "devices.platform":          "Plattform",
  "devices.last_seen":         "Zuletzt aktiv",
  "devices.added":             "Hinzugefügt",
  "devices.revoke":            "Entfernen",
  "devices.empty.title":       "Noch keine Geräte",
  "devices.empty.subtitle":    "Installiere die App und gib den 6-stelligen Pairing-Code hier ein.",
  "devices.add.title":         "Neues Gerät hinzufügen",
  "devices.add.desc":          "Öffne die App auf TV oder Handy und gib den 6-stelligen Code vom Bildschirm ein.",
  "devices.add.code":          "Pairing-Code",
  "devices.add.submit":        "Koppeln",
  "devices.add.hint":          "Der Code ist 6-stellig und rein numerisch.",
  "devices.revoke.title":      "Gerät entfernen",
  "devices.revoke.desc":       "{name} wird von deinem Konto abgemeldet und benötigt einen neuen Code.",
  "devices.revoke.confirm":    "Entfernen",
  "devices.revoke.cancel":     "Abbrechen",

  "app.title":                 "App herunterladen",
  "app.subtitle":              "Auf jedem Gerät. Gleiches Konto, gleiches Abo.",
  "app.detected":              "Erkanntes Gerät:",
  "app.download":              "Herunterladen",
  "app.qr.title":              "Mit dem Handy scannen",
  "app.qr.desc":               "Scanne den QR-Code, um die mobile App aus dem Store zu installieren.",
  "app.platform.android":      "Android",
  "app.platform.ios":          "iOS",
  "app.platform.android_tv":   "Android TV",
  "app.platform.fire_tv":      "Fire TV",
  "app.platform.apple_tv":     "Apple TV",
  "app.platform.samsung_tv":   "Samsung Smart TV",
  "app.platform.lg_tv":        "LG webOS",
  "app.platform.windows":      "Windows",
  "app.platform.mac":          "macOS",
  "app.platform.web":          "Web",
  "app.platform.desktop":      "Desktop",

  "footer.copyright":          "© {year} {brand}. Alle Rechte vorbehalten.",
  "footer.terms":              "Bedingungen",
  "footer.privacy":            "Datenschutz",
  "footer.support":            "Support",
  "footer.status":             "Status",

  "common.cancel":             "Abbrechen",
  "common.save":               "Speichern",
  "common.loading":            "Laden…",
  "common.error":              "Etwas ist schiefgelaufen",
};

export default de;
